import { OPEN_MODAL, CLOSE_MODAL } from "/@src/redux/contants";
export function closeModal(id) {
  return {
    type: CLOSE_MODAL,
    payload: id,
  };
}

export function openModal(data) {
  return {
    type: OPEN_MODAL,
    payload: data,
  };
}
